export default __webpack_public_path__ + "static/media/save_simulation.1dad84fb.svg";